import { APIAuthClient } from 'service/apicataleg/api/APIHttpClient';
import {
  CartCap,
  CreateCartRequest,
  OrderCreationResult,
} from 'service/apicataleg/types/ApiCatalegTypes';

const CartClientService = {
  async createCart(request: CreateCartRequest): Promise<CartCap | null> {
    try {
      const { data } = await APIAuthClient.post('/client/cart', request);
      return data;
    } catch (error) {
      console.error(error);
      return null;
    }
  },

  async getClientCarts(): Promise<Array<CartCap>> {
    try {
      const { data } = await APIAuthClient.get(`/client/cart/cap/all`);
      return data;
    } catch (error) {
      console.error(error);
      return [];
    }
  },

  async createOrder(idCart: number): Promise<OrderCreationResult> {
    return APIAuthClient.post<Array<number>>(`/client/cart/${idCart}/order`)
      .then((res) => {
        return { error: false, message: '', npes: res.data };
      })
      .catch((error) => {
        return { error: true, message: error.response, npes: [] };
      });
  },
};

export default CartClientService;
